import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/EquityReleaseCalculator.jpg";
import EquityReleaseCalculator from "../../frontend/components/calculators/EquityReleaseCalculator";

const EquityReleasePage = () => {
  return (
    <div>
      <Hero
        title="Equity Release"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <EquityReleaseCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default EquityReleasePage;
